/**
 * Plugin for linking an owl instance as preview for another
 */

import $ from 'jquery';


/**
 * Creates the PreviewFor plugin.
 * @class The PreviewFor Plugin
 * @param {Owl} carousel - The Owl Carousel
 */
var PreviewFor = function(carousel) {
    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * All event handlers for this olw instance.
     * @protected
     * @type {Object}
     */
    this._handlers = {
        'initialized.owl.carousel': $.proxy(function(e) {
            if (this._core.settings.previewFor) {
                // reflect the initial index of the host
                var $hostActiveItems = $(this.host).find('.owl-item.active');
                if($hostActiveItems.length > 0) {
                    var index = $hostActiveItems.index();
                    this.updatePreview(index);
                }
            }
        }, this),
    };
    this._core.$element.on(this._handlers);

    /**
     * All event handlers for links inside this owl instance.
     * @protected
     * @type {Object}
     */
    this._linkHandlers = {
        'click': $.proxy(function(e) {
            if (this._core.settings.previewFor) {
                this.handlePreviewClick(e);
            }
        }, this),
    };
    $("a", this._core.$element).on(this._linkHandlers);

    /**
     * All event handlers for the host owl instance.
     * @protected
     * @type {Object}
     */
    this._hostHandlers = {
        'dragged.owl.carousel changed.owl.carousel': $.proxy(function(e) {
            if (e.namespace && this._core.settings.previewFor) {
                var index = e.relatedTarget.relative(e.item.index);
                this.updatePreview(index);
            }
        }, this),
        'initialized.owl.carousel': $.proxy(function(e) {
            if (e.namespace && this._core.settings.previewFor) {
                this.updatePreview(e.item.index)
            }
        }, this),
    };
    this.host = typeof this._core.options.previewFor === 'string' ? "#"+this._core.options.previewFor : this._core.options.previewFor;
    $(this.host).on(this._hostHandlers);

    // set default options
    this._core.options = $.extend({}, PreviewFor.Defaults, this._core.options);
};

/**
 * Default options.
 * @public
 */
PreviewFor.Defaults = {
    previewFor: false,
};

/**
 * Update the preview instance
 * @param {integer} previewIndex - The index of the new item
 * @protected
 */
PreviewFor.prototype.updatePreview = function(previewIndex) {
    // calculate the page containing the target index
    var itemCount = this._core._items.length;
    var pageSize = this._core.settings.items;
    var previewPage = Math.min( Math.floor(previewIndex / pageSize), itemCount - pageSize );

    // go to the page
    this._core.$element.trigger('to.owl.carousel', previewPage);

    // set the highlight class
    this.setHighlight(previewIndex);
};

/**
 * Update linked instances
 * @param {object} e - The click event data
 * @protected
 */
PreviewFor.prototype.handlePreviewClick = function(e) {
    e.preventDefault();

    // get the index of the clicked item
    var index = this._core.$stage.children().has(e.target).index();

    // set the highlight and trigger the host instance
    this.setHighlight(index);
    $(this.host).trigger('to.owl.carousel', index);
};

/**
 * Highlight the preview item that is shown in the host instance
 * @param {integer} previewIndex - The index of the preview item that should be highlighted
 * @protected
 */
PreviewFor.prototype.setHighlight = function(previewIndex) {
    this._core.$stage.children(".highlight").removeClass("highlight");
    this._core.$stage.children().eq(previewIndex).addClass("highlight");
};

/**
 * Destroys the plugin.
 * @protected
 */
PreviewFor.prototype.destroy = function() {
    var handler, property;

    for (handler in this._handlers) {
        this._core.$element.off(handler, this._handlers[handler]);
    }

    for (handler in this._linkHandlers) {
        $("a", this._core.$element).off(handler, this._linkHandlers[handler]);
    }

    for (handler in this._hostHandlers) {
        $(this.host).off(handler, this._hostHandlers[handler]);
    }

    for (property in Object.getOwnPropertyNames(this)) {
        typeof this[property] != 'function' && (this[property] = null);
    }
};

$.fn.owlCarousel.Constructor.Plugins.previewFor = PreviewFor;
